export default "__VITE_ASSET__80e5180a__"